import { Map } from 'immutable';

export default Map({
  loading: false,
  error: null,
  isOpen: false,
  subjects: [],
});
